import { Nullable } from "../ReactUIUtilituTypes";

import { CurrencyHelper } from "./CurrencyHelper";
import { CursorHelper } from "./CursorHelper";
import { Selection } from "./SelectionHelper";

export interface DecimalOptions {
    integerDigits?: Nullable<number>;
    fractionDigits?: Nullable<number>;
    unsigned?: boolean;
}

export class CurrencyInputHelper {
    public static thinSpaceSymbol = " ";

    public static moveCursor(value: string, selection: Selection, step: number): number {
        return selection.start === selection.end
            ? CursorHelper.calculatePosition(CurrencyHelper.getInfo(value).cursorMap, selection.start, step)
            : step < 0
              ? selection.start
              : selection.end;
    }

    public static extendSelection(value: string, selection: Selection, step: number) {
        const info = CurrencyHelper.getInfo(value);
        return CursorHelper.extendSelection(info.cursorMap, selection, step);
    }

    public static normalizeSelection(value: string, selection: Selection): Selection {
        const info = CurrencyHelper.getInfo(value);
        return CursorHelper.normalizeSelection(info.cursorMap, selection);
    }

    public static safeInsert(value: string, start: number, end: number, input: string, options: DecimalOptions) {
        if (input && start === 0 && end === value.length) {
            const extracted = CurrencyHelper.extractValid(input, options);
            if (!extracted) {
                return null;
            }
            return CurrencyInputHelper.insert(value, start, end, extracted);
        }

        const prefix = value.substring(0, start);
        const suffix = value.substring(end);
        const combined = prefix + input + suffix;

        const isDeleteComma = value.substring(start, end) === ",";
        if (isDeleteComma && options.integerDigits != undefined) {
            return CurrencyInputHelper.insertComma(start, combined, options.integerDigits);
        }

        if (CurrencyHelper.isValidString(combined, options)) {
            return CurrencyInputHelper.insert(value, start, end, input);
        }

        if (!CurrencyHelper.isValidString(combined, options) && input === "") {
            return CurrencyInputHelper.insert(value, start, end, input);
        }

        return null;
    }

    public static insert(value: string, start: number, end: number, input: string) {
        const prefix = value.substring(0, start);
        const suffix = value.substring(end);

        const info = CurrencyHelper.getInfo(value);
        const raw = CursorHelper.toRawPosition(info.cursorMap, start);
        const info2 = CurrencyHelper.getInfo(prefix + input + suffix);
        const formattedPosition = CursorHelper.toFormattedPosition(info2.cursorMap, raw + input.length);

        return { value: info2.formatted, position: formattedPosition };
    }

    public static insertComma(start: number, combined: string, integerDigits: number) {
        const combinedWithoutSpace = combined.replace(CurrencyInputHelper.thinSpaceSymbol, "");
        const comma = combinedWithoutSpace === "" ? "" : ",";
        combined =
            combinedWithoutSpace.substring(0, integerDigits) + comma + combinedWithoutSpace.substring(integerDigits);
        combined = CurrencyHelper.formatString(combined);
        return { value: combined, position: start };
    }
}
